import React from 'react';
import { inject, observer } from 'mobx-react';
import E9Login from './e9login/E9Login';

@inject('portalLoginStore')
@observer
class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { portalLoginStore, location } = this.props;
    const { state } = portalLoginStore;
    const { templateType } = state;
    if (templateType == 'ECustom') {
      // 加载自定义登录组件
      const { layoutData } = state;
      portalLoginStore.onLoadECustomLogin(layoutData);
    }
    // 设置路由参数
    portalLoginStore.setQueryParams(location.query);
    // 获取升级信息
    portalLoginStore.getUpgradeInfo(location.query);
  }

  componentWillReceiveProps(nextProps) {
    const { portalLoginStore, location } = nextProps;
    portalLoginStore.setQueryParams(location.query);
  }

  render() {
    const { portalLoginStore } = this.props;
    const { updatestatus, casstatus, beforLoginRenderEventStatus, state, eCustomLoading } = portalLoginStore;
    const { id, templateType, layoutData = {} } = state;

    if (updatestatus != '0' || casstatus != '0' || !beforLoginRenderEventStatus || !id) {
      return <div />;
    }

    switch (templateType) {
      case 'ECustom':
        const { layoutId, layoutType, layoutCustom, layoutConfig = {}, layoutUUID } = layoutData;

        if (layoutCustom == '1') {
          // 使用自定义登录组件
          if (eCustomLoading && window[layoutConfig.module]) {
            const ECustomLogin = window[layoutConfig.module]['com'][layoutConfig.component];
            return <ECustomLogin {...this.props} />;
          } else {
            if (window.rewritePortalLogin && typeof window.rewritePortalLogin == 'function') {
              return window.rewritePortalLogin({...this.props}, {id: layoutUUID});
            } else {
              return <div />;
            }
          }
        } else {
          // 使用特色门户布局
          if (eCustomLoading && window['weaPortalPublic']) {
            return <window.weaPortalPublic.WeaPortalLayout {...this.props} id={layoutId} layoutType={layoutType} />;
          } else {
            return <div />;
          }
        }
      case 'E9':
        return <E9Login />;
      default:
        return <E9Login />;
    }
  }
}

export default Login;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/index.js